import React, { useEffect, useRef, useState } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { getApi, postApi, putApi } from '../../../Services/apiService';
import { filteredCategories } from '../../../Utils/helper';
import { toast } from 'react-toastify';
function SingleEditReserve({ 
  toggleAddReserve, 
  formData,
  handleReserveQuantityChanges,
  handleInputChanges,
  handleResets,
  customerGroupData, 
  setFormData,
  handleCustomerGroupId,
  customerSubGroupData, 
  getReserveData,
  getFilterData,
  filterDatass,
  searchTerms,
  setSearchTerms
}) {
  const dropdownRef = useRef();
  const { RangePicker } = DatePicker;
//   const [formData, setFormData] = useState({
//     customerGroup: '',
//     customersubgroup: '',
//     product: '',
//     promotionType: '',
//     dateRange: [{
//       start: null,
//       end: null
//     }],
//     promotionDateRange: [
//       {
//       start: null,
//       end: null
//     }
//   ],
//     DateRangeData: []
//   });
  console.log("formDataformData",formData);
  
  
  const [productData, setProductData] = useState([]);
  const [customerGroupDropdown, setCustomerGroupDropdown] = useState(false);
  const [customerSubGroupDropdown, setCustomerSubGroupDropdown] = useState(false);
  const [productDropdown, setProductDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDatas, setFilterData] = useState([]);
  const [existingReserves, setExistingReserves] = useState([]);
  const [loadingExistingReserves, setLoadingExistingReserves] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    dateRange: '',
    customerGroup: '',
    customersubgroup: '',
    product: '',
    DateRangeData: ''
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setCustomerGroupDropdown(false);
        setCustomerSubGroupDropdown(false);
        setProductDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    handleGetProduct();
  }, []);

  useEffect(() => {
    if (searchTerm !== '') {
      if (customerGroupDropdown) {
        const data = filteredCategories(searchTerm, customerGroupData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (customerSubGroupDropdown) {
        const data = filteredCategories(searchTerm, customerSubGroupData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (productDropdown) {
        const data = filteredCategories(searchTerm, productData);
        setFilterData(data?.length > 0 ? data : []);
      }
    }
  }, [searchTerm]);

  useEffect(() => {
    if (formData.dateRange[0]?.start && formData.dateRange[0]?.end) {
      const startDate = dayjs(formData.dateRange[0].start);
      const endDate = dayjs(formData.dateRange[0].end);
      const promoStart = formData.promotionDateRange[0]?.start ? dayjs(formData.promotionDateRange[0].start) : null;
      const promoEnd = formData.promotionDateRange[0]?.end ? dayjs(formData.promotionDateRange[0].end) : null;

      const daysDiff = endDate.diff(startDate, 'day');
      const newDateRangeData = [];

      for (let i = 0; i <= daysDiff; i++) {
        const currentDate = startDate.add(i, 'day');
        const dateStr = currentDate.format('YYYY-MM-DD');

        const currentDateStr = currentDate.format('YYYY-MM-DD');
        const promoStartStr = promoStart ? promoStart.format('YYYY-MM-DD') : null;
        const promoEndStr = promoEnd ? promoEnd.format('YYYY-MM-DD') : null;

        const isInPromoRange = promoStartStr && promoEndStr &&
          currentDateStr >= promoStartStr &&
          currentDateStr <= promoEndStr;

        const existingReserve = existingReserves.find(reserve => reserve.date === dateStr);

        newDateRangeData.push({
          date: dateStr,
          quantity: existingReserve?.quantity || '',
          promotionType: isInPromoRange ? formData.promotionType : (existingReserve?.promotion_type || '')
        });
      }

      setFormData(prev => ({
        ...prev,
        DateRangeData: newDateRangeData
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        DateRangeData: []
      }));
    }
  }, [
    formData.dateRange,
    formData.promotionDateRange,
    formData.promotionType,
    existingReserves
  ]);

  useEffect(() => {
    const fetchExistingReserves = async () => {
      if (formData.dateRange[0]?.start && formData.dateRange[0]?.end && 
          formData.customerGroup && formData.customersubgroup && formData.product) {
        try {
          setLoadingExistingReserves(true);
          
          const queryParams = new URLSearchParams();
          queryParams.append('product_ids[]', formData.product);
          queryParams.append('from_date', formData.dateRange[0].start);
          queryParams.append('to_date', formData.dateRange[0].end);
          queryParams.append('customer_group_ids[]', formData.customerGroup);
          queryParams.append('customer_sub_group_ids[]', formData.customersubgroup);
          queryParams.append('per_page', 999);
          
          const response = await getApi(`/reserve?${queryParams.toString()}`);
          
          if (response?.success) {
            setExistingReserves(response.data.reserves.data);
          }
        } catch (error) {
          console.error('Error fetching existing reserves:', error);
        } finally {
          setLoadingExistingReserves(false);
        }
      }
    };
    
    const debounceTimer = setTimeout(fetchExistingReserves, 500);
    
    return () => clearTimeout(debounceTimer);
  }, [
    formData.dateRange,
    formData.customerGroup,
    formData.customersubgroup,
    formData.product
  ]);

  const handleGetProduct = async () => {
    const resp = await getApi('/product?per_page=100');
    if (resp?.success) {
      setProductData(resp?.data?.products?.data);
    }
  };

  const validateForm = () => {
    const errors = {
      dateRange: '',
      customerGroup: '',
      customersubgroup: '',
      product: '',
      DateRangeData: ''
    };
    let isValid = true;
    if (formData.dateRange[0]?.start==null || formData.dateRange[0]?.end==null) {
      errors.dateRange = 'Date range is required';
      isValid = false;
    }
    
    if (!formData.customerGroup) {
      errors.customerGroup = 'Customer group is required';
      isValid = false;
    }
    
    if (!formData.customersubgroup) {
      errors.customersubgroup = 'Customer subgroup is required';
      isValid = false;
    }
    
    if (!formData.product) {
      errors.product = 'Product is required';
      isValid = false;
    }
    
    // if (formData.DateRangeData.length > 0) {
    //   const hasQuantity = formData.DateRangeData.some(item => item.quantity && item.quantity > 0);
    //   if (!hasQuantity) {
    //     errors.DateRangeData = 'At least one date must have reserve quantity';
    //     isValid = false;
    //   }
    // } else {
    //   errors.DateRangeData = 'No dates available - please select a valid date range';
    //   isValid = false;
    // }

    setValidationErrors(errors);
    return isValid;
  };

  const handleInputBlur = (field) => {
    if (field === 'dateRange' && (formData.dateRange[0]?.start==null || formData.dateRange[0]?.end==null)) {
      setValidationErrors(prev => ({
        ...prev,
        dateRange: 'Date range is required'
      }));
    }
    
    if (field === 'customerGroup' && !formData.customerGroup) {
      setValidationErrors(prev => ({
        ...prev,
        customerGroup: 'Customer group is required'
      }));
    }
    
    if (field === 'customersubgroup' && !formData.customersubgroup) {
      setValidationErrors(prev => ({
        ...prev,
        customersubgroup: 'Customer subgroup is required'
      }));
    }
    
    if (field === 'product' && !formData.product) {
      setValidationErrors(prev => ({
        ...prev,
        product: 'Product is required'
      }));
    }
  };

  const handleDateFilterChange = (dates, type) => {
    if (type === 'dateRange') {
      if (dates) {
        setFormData(prev => ({
          ...prev,
          dateRange: [{
            start: dates[0] ? dayjs(dates[0]).format('YYYY-MM-DD') : null,
            end: dates[1] ? dayjs(dates[1]).format('YYYY-MM-DD') : null
          }],
        }));
        
        if (dates[0] && dates[1]) {
          setValidationErrors(prev => ({
            ...prev,
            dateRange: ''
          }));
        }
      } else {
        setFormData(prev => ({
          ...prev,
          dateRange: [{
            start: null,
            end:  null
          }],
        }));
      }
    }
    if (type === 'promotion') {
      if (dates) {
        setFormData(prev => ({
          ...prev,
          promotionDateRange: [{
            start: dates[0] ? dayjs(dates[0]).format('YYYY-MM-DD') : null,
            end: dates[1] ? dayjs(dates[1]).format('YYYY-MM-DD') : null
          }],
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          promotionDateRange: [{
            start: null,
            end: null
          }],
        }));
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleReserveQuantityChange = (index, value) => {
    
    setFormData(prev => ({
      ...prev,
      quantity: value
    }));
  };

  const handleCustomerGroupSelect = (group) => {
    const newValue = formData.customerGroup === group.group_id ? '' : group.group_id;
    setFormData(prev => ({
      ...prev,
      customerGroup: newValue
    }));
    
    if (newValue) {
      setValidationErrors(prev => ({
        ...prev,
        customerGroup: ''
      }));
    }
    
    setCustomerGroupDropdown(false);
  };

  const handleCustomerSubGroupSelect = (group) => {
    const newValue = formData.customersubgroup === group.id ? '' : group.id;
    setFormData(prev => ({
      ...prev,
      customersubgroup: newValue
    }));
    
    if (newValue) {
      setValidationErrors(prev => ({
        ...prev,
        customersubgroup: ''
      }));
    }
    
    setCustomerSubGroupDropdown(false);
  };

  const handleProductSelect = (product) => {
    const newValue = formData.product === product.id ? '' : product.id;
    setFormData(prev => ({
      ...prev,
      product: newValue
    }));
    
    if (newValue) {
      setValidationErrors(prev => ({
        ...prev,
        product: ''
      }));
    }
    
    setProductDropdown(false);
  };

  const handleReset = () => {
    setFormData({
      customerGroup: '',
      customersubgroup: '',
      product: '',
      promotionType: '',
      dateRange: [{
        start: null,
        end: null
      }],
      promotionDateRange: [{
        start: null,
        end: null
      }],
      DateRangeData: []
    });
    setExistingReserves([]);
    setValidationErrors({
      dateRange: '',
      customerGroup: '',
      customersubgroup: '',
      product: '',
      DateRangeData: ''
    });
  };

  const handleReserveUpdate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
        if(formData?.quantity==0){
            toast.error('please fill the reserve quantity')
            return;
        }
      const urlEncodedData = new URLSearchParams();
      urlEncodedData.append('quantity', formData?.quantity);

      const response = await putApi(`/reserve/${formData?.id}`, urlEncodedData.toString());

      if (response?.success === true) {
        toast.success(response.msg || 'Reserve added successfully');
        getReserveData();
        toggleAddReserve();
      } else {
        toast.error(response?.msg || 'Failed to add reserve');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.msg || error.message || 'Failed to add reserve';
      toast.error(errorMsg);
      console.error('Error submitting reserve:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="setting-right position-relative add-reserve">
          <h3>Edit Reserve</h3>
                   <div className="button-settings">
                  <div className="col-sm-12">
                    <div className="d-flex justify-content-end gap-3">
                      <button type="button" className="reset" onClick={handleReset}>
                        Reset
                      </button>
                      <button type="submit" className="save" disabled={isSubmitting}>
                        {isSubmitting ? 'Saving...' : 'Save'}
                      </button>
                    </div>
                  </div>
                </div>
          <img
            src={window.getPublicUrl('/assets/images/close.svg')}
            className="close"
            alt=""
            onClick={toggleAddReserve}
          />
          <div className="setting-inner">
            <form onSubmit={handleReserveUpdate} method="post">
              <div className="row">
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>Date<strong>*</strong></label>
                    {/* <RangePicker
                      key={'dateRange'}
                      onChange={(e) => handleDateFilterChange(e, 'dateRange')}
                      separator={'-'}
                    value={
                        formData?.dateRange[0]?.start && formData?.dateRange[0]?.end
                          ? [dayjs(formData.dateRange[0].start), dayjs(formData.dateRange[0].end)]
                          : null
                      }
                      allowClear={false}
                      disabled={formData?.dateRange[0]?.start && formData?.dateRange[0]?.end
                        ? [dayjs(formData.dateRange[0].start), dayjs(formData.dateRange[0].end)]
                        : null}
                    /> */}
                    <input
                        type="date"
                        className="form-control"
                        value={formData?.dateRange?.[0]?.start || ''}
                        onChange={(e) => handleDateFilterChange([{
                        ...formData.dateRange?.[0],
                        start: e.target.value
                        }], 'dateRange')}
                        disabled
                    />
                    {validationErrors.dateRange && (
                      <div className="invalid-feedback d-block">
                        {validationErrors.dateRange}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="form-group position-relative">
                    <label>Customer Group<strong>*</strong></label>
                    <input
                      placeholder="Customer Group"
                      className={`form-control ${validationErrors.customerGroup ? 'is-invalid' : ''} ${customerGroupDropdown ? 'before-change-cs' : ''}`}
                      value={formData.customerGroup}
                    //   onClick={() => {
                    //     setCustomerGroupDropdown(!customerGroupDropdown);
                    //     setSearchTerm('');
                    //   }}
                    //   onChange={(e) => setSearchTerm(e.target.value)}
                      // onBlur={() => handleInputBlur('customerGroup')}
                    />
                    {validationErrors.customerGroup && (
                      <div className="invalid-feedback d-block">
                        {validationErrors.customerGroup}
                      </div>
                    )}
                    {customerGroupDropdown && (
                      <div className="select-option w-100" ref={dropdownRef}>
                        {(searchTerm === '' ? customerGroupData?.length > 0 : filterDatas?.length > 0)
                          ? (searchTerm === '' ? customerGroupData : filterDatas).map(group => (
                            <span key={group.group_id} onClick={() => handleCustomerGroupSelect(group)}>
                              <label className="checbox-cs">
                                <input
                                  type="checkbox"
                                  checked={formData.customerGroup === group.group_id}
                                  onChange={() => {}}
                                />
                                <span className="checkmark"></span>
                              </label>
                              {group.name}
                            </span>
                          ))
                          : <span className="no-data-available">No Customer Groups Available</span>
                        }
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="form-group position-relative">
                    <label>Customer Sub Group<strong>*</strong></label>
                    <input
                      placeholder="Customer Sub Group"
                      className={`form-control ${validationErrors.customersubgroup ? 'is-invalid' : ''} ${customerSubGroupDropdown ? 'before-change-cs' : ''}`}
                      value={formData.customersubgroup}
                    //   onClick={() => {
                    //     setCustomerSubGroupDropdown(!customerSubGroupDropdown);
                    //     setSearchTerm('');
                    //   }}
                    //   onChange={(e) => setSearchTerm(e.target.value)}
                      // onBlur={() => handleInputBlur('customersubgroup')}
                    />
                    {validationErrors.customersubgroup && (
                      <div className="invalid-feedback d-block">
                        {validationErrors.customersubgroup}
                      </div>
                    )}
                    {customerSubGroupDropdown && (
                      <div className="select-option w-100" ref={dropdownRef}>
                        {(searchTerm === '' ? customerSubGroupData?.length > 0 : filterDatas?.length > 0)
                          ? (searchTerm === '' ? customerSubGroupData : filterDatas).map(group => (
                            <span key={group.id} onClick={() => handleCustomerSubGroupSelect(group)}>
                              <label className="checbox-cs">
                                <input
                                  type="checkbox"
                                  checked={formData.customersubgroup === group.id}
                                  onChange={() => {}}
                                />
                                <span className="checkmark"></span>
                              </label>
                              {group.name}
                            </span>
                          ))
                          : <span className="no-data-available">No Customer Sub Groups Available</span>
                        }
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="form-group position-relative">
                    <label htmlFor="product">Product<strong>*</strong></label>
                    <input
                      placeholder="Product"
                      className={`form-control ${validationErrors.product ? 'is-invalid' : ''} ${productDropdown ? 'before-change-cs' : ''}`}
                      value={formData.product}
                    />

                  </div>
                </div>
                {/* <div className="col-sm-3">
                  <div className='d-flex gap-5 specification'>
                    <div className=''>
                      <p>Product Code:</p>
                      <h5>
                        {formData.product_code }
                      </h5>
                    </div>
                    <div className=''>
                      <p>Specification</p>
                      <h5>
                        {formData.specification}
                      </h5>
                    </div>
                  </div>
                </div> */}

                <div className="table-container p-0">
                  <table className="custom-table table">
                    <thead>
                      <tr>
                        <th className="date">Date</th>
                        <th className="reserve-quantity">Reserve Quantity</th>
                        <th className="promotion-type">Promotion Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData?.DateRangeData.map((item, index) => (
                        <tr key={index}>
                          <td className="date">{item.date}</td>
                          <td className="reserve-quantity">
                            <input
                              type="number"
                              value={formData.quantity}
                            //   value={item.quantity}
                              onChange={(e) => handleReserveQuantityChange(index, e.target.value)}
                              placeholder="10"
                              min={0}
                            />
                          </td>
                          <td className="promotion-type">{formData.promotionType}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {validationErrors.DateRangeData && (
                    <div className="invalid-feedback d-block text-center mt-2">
                      {validationErrors.DateRangeData}
                    </div>
                  )}
                </div>

                {/* <div className="button-settings">
                  <div className="col-sm-12">
                    <div className="d-flex justify-content-end gap-3">
                      <button type="button" className="reset" onClick={handleReset}>
                        Reset
                      </button>
                      <button type="submit" className="save" disabled={isSubmitting}>
                        {isSubmitting ? 'Saving...' : 'Save'}
                      </button>
                    </div>
                  </div>
                </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SingleEditReserve;